import React from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import config from '../../data/siteConfig'

const Map = withScriptjs(withGoogleMap((props) => {
  return <GoogleMap
    defaultZoom={10}
    defaultOptions={{mapTypeControl: false}}
    defaultCenter={{ lat: config.siteLat, lng: config.siteLng }}
  >
    {props.isMarkerShown && <Marker position={{ lat: config.siteLat, lng: config.siteLng }} />}
  </GoogleMap>
}))

export default Map


// WEBPACK FOOTER //
// ./src/components/Map.js